import { render } from "./ProgramForm.vue?vue&type=template&id=35aff132"
import script from "./ProgramForm.vue?vue&type=script&lang=js"
export * from "./ProgramForm.vue?vue&type=script&lang=js"

import "./ProgramForm.vue?vue&type=style&index=0&id=35aff132&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__